export const mandatoryPermissionIds: string[] = [ 
	'9e046657-660c-40a1-ab94-05b328a7af33',
	'b8be198e-e35d-4d39-86c9-71e07c81a2ac',
	'd4d7f746-7927-4d2e-98e1-a406add41167',
	'dc6cfc39-ffb1-44c3-a265-4ba0287a9382',
	'32d8d37d-2303-4f57-bcd5-6985b733c567',
	'9d116329-3e28-4f56-b6be-5287db26e3f4',
	'66db5601-da52-4b85-a045-3aecbe395b33' ];

export const individualUserRoleId: string = 'da3efd60-cc1f-492e-b0eb-7c7b50a3b357';
export const customerServiceEmail: string = 'customerservice@toyotatmh.com';
export const individualUserPermissionMessage = 'To enable this feature, please contact MyToyota Customer Service at customerservice@toyotatmh.com to migrate to a MyToyota Business Account.';
export const nullCheckValue='—';
export const companyAdminRoleId: string = 'eeb8928f-3ca2-4388-9acb-411e043806e7';
export const tmhCorporateAdminRoleId: string = '9fbdd4da-6f7d-4dbf-a0c1-e7d0095f82fd';
export const tmhCustomerSupportRoleId: string = '3eee9190-4a0d-457a-90ba-6ab51af9e763';
export const accountManagerRoleId: string = '557d334a-9edc-42a5-9fa4-bb87065ec17d';
export const defaultPage = 0;
export const permissionRequired: string = 'Permission Required';
export const canadaZipFormat = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
export const uploadLimitText: string = 'You can invite up to 200 contacts in a single upload.';
export const uploadLimit: string = 'Upload Limit: ';
export const batteryStateOfChargeNullValue: string = 'N/A';

export const removePermissionIdsforCustomRole: string[] = [
	'5f754220-ba91-495f-8065-3b32c363558f',
	'f3364b91-d2c5-4a92-b3fe-d19480484dd4',
	'b78feec0-e49d-434e-a682-8d8a856135ba',
	'9a6385de-6cd3-4509-b915-a509ecd62b1b',
	'd51a4d83-2d6c-4539-815f-91fb29137539',
	'd50fa867-32c8-4c3f-b2c1-c6cc17cd0f8a',
	'5e4630ca-e14f-4fa0-b191-16b52d289097',
	'154b9fde-97c4-4a40-82c4-afd0dd2a5206',
	'35022a56-49b9-46b0-b9c5-6f8d0fd720d3',
	'bb95f4cf-bd37-4f50-be9e-53dd0efa9869'
];

export const idValuePairs = {
	'23b780e9-5289-4089-819f-dba91259eaa1': 'phoneNumber' 
};
